import EventBus from "eventing-bus"
import gsap from "gsap"
import { constants, getCurrSection, getPrevSection, getModelsArr, getTruckModelsArr, getCurrBoard, getCurrTruck } from "../model"

const THIS_SECTION_NUM = 1,
  truckAnimationDistanceX = 8

let tempTrucksArr = [],
  board = null,
  isFirstTime = true,
  truckAddedToGroup = false

/**
 * Event handlers
 */
const handleSectionChanged = () => {
  // If going back to 0 from 1 OR going from 2 to 1 OR coming from 3
  if (
    (getPrevSection() === 1 && getCurrSection() === 0) ||
    (getPrevSection() === 2 && getCurrSection() === 1) ||
    (getPrevSection() === 2 && getCurrSection() === 0) ||
    (getPrevSection() === 3 && getCurrSection() === 0) ||
    (getPrevSection() === 3 && getCurrSection() === 1)
  ) {
    clearTrucks()
    truckAddedToGroup = false
  }
  if (getPrevSection() === 0 && getCurrSection() === 2) {
    clearTrucks()
    buildTrucks()
    setTimeout(() => {
      animateNewTrucksIn()
      truckAddedToGroup = true
    }, 1000)
  }
  if (getCurrSection() === 3) {
    if (!truckAddedToGroup) {
      buildTrucks()
      animateNewTrucksIn()
    }
    truckAddedToGroup = true
  }
  if (getCurrSection() === THIS_SECTION_NUM) {
    buildTrucks()
    setTimeout(() => {
      animateNewTrucksIn()
      truckAddedToGroup = true
    }, 1000)
    isFirstTime = false
  }
}

const clearTrucks = () => {
  tempTrucksArr.map((d, i) => {
    board.remove(d)
  })
}

const handleTruckChanged = () => {
  const duration = 0.4,
    originalX = board.position.x

  gsap.to(board.position, { duration, x: 0.02, ease: "power3.out" })
  gsap.to(board.position, { duration: 0.7, x: originalX, delay: 0.3, ease: "power2.inOut" })

  tempTrucksArr.map((d) => {
    gsap.to(d.position, {
      duration: 0.4,
      x: truckAnimationDistanceX,
      ease: "power3.in",
      onComplete: () => {
        d.visible = false
        board.remove(d)
      },
    })
  })
  setTimeout(() => {
    buildTrucks()
    animateNewTrucksIn()
  }, 700)
}

EventBus.on(constants.SECTION_CHANGED, handleSectionChanged)
EventBus.on(constants.TRUCK_CHANGED, handleTruckChanged)

/**
 * Fn
 */

const buildTrucks = () => {
  const truckModel = getTruckModelsArr()[getCurrTruck()].model,
    copy = truckModel.clone()

  board = ""
  board = getModelsArr()[getCurrBoard()].group

  tempTrucksArr = []
  tempTrucksArr = [truckModel, copy]
  truckModel.visible = false
  copy.visible = false
  board.add(truckModel)
  board.add(copy)
}

const animateNewTrucksIn = () => {
  const truckModel = tempTrucksArr[0],
    copy = tempTrucksArr[1],
    duration = 1,
    animationDistance = 8

  truckModel.rotation.z = Math.PI
  gsap.fromTo(
    truckModel.position,
    { x: -animationDistance, y: 2.48 },
    { onStart: () => (truckModel.visible = true), duration: duration + 0.3, x: 0, ease: "power4.out" }
  )

  copy.rotation.z = 0
  gsap.fromTo(
    copy.position,
    { x: -animationDistance, y: -2.6 },
    { onStart: () => (copy.visible = true), duration, x: 0, ease: "power4.out" }
  )
}
